module.exports = __webpack_public_path__ + "static/media/dummy_throughput.711c05da.png";